import * as React from 'react'

import { EnvironmentContext } from 'config/environment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { loadMeetingsCalendar } from 'modules/onboarding/lib/hubspot/meetings'
import type { MeetingPayload } from 'modules/onboarding/lib/hubspot/meetings'

interface HubspotMeetingsWrapperProps {
  isUpsellMeeting: boolean
  onMeetingBooked?: (data: MeetingPayload) => void
}

const HubspotMeetingsWrapper = ({
  isUpsellMeeting,
  onMeetingBooked,
}: HubspotMeetingsWrapperProps) => {
  const session = useCurrentSession()
  const ref = React.useRef<HTMLDivElement>(null)
  const { captureExplicitSentryErrors } = React.useContext(EnvironmentContext)

  useUnsafeEffect(() => {
    if (ref.current) {
      loadMeetingsCalendar(
        ref.current.id,
        captureExplicitSentryErrors,
        isUpsellMeeting,
        session,
        onMeetingBooked
      )
    }
  }, [ref, captureExplicitSentryErrors, isUpsellMeeting, onMeetingBooked, session])

  return <div id="hubspot-meetings-entrypoint-wrapper" ref={ref} style={{ height: '100%' }} />
}

export default HubspotMeetingsWrapper
